import React, { useState } from 'react'
import { atlTheme } from '../../atlTheme'
import styled from 'styled-components'
import { ConstructionProgressScreen } from './ConstructionProgressScreen'
import { ConstructionMediaScreen } from './ConstructionMediaScreen'
import { ConstructionDocumentsScreen } from './ConstructionDocumentsScreen'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'

interface ButtonProps {
  border: boolean
}

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  height: ${atlTheme.HeightButtonBase}px;
`

const Button = styled.button<ButtonProps>`
  width: 100%;
  border: none;
  color: ${atlTheme.ColorBrand1Default};
  text-transform: uppercase;
  font-size: ${atlTheme.FontSizeHeading}px;
  font-family: ${atlTheme.FontFamilyBrand};
  background-color: ${atlTheme.ColorWhite};
  border-bottom: ${props => props.border && `2px solid ${atlTheme.ColorBrand2Default}`};
`

const emptyPages = { constructionProgress: false, constructionMedia: false, constructionDocuments: false }

export const ConstructionsTabs = () => {
  const [actualPage, setActualPage] = useState({
    ...emptyPages,
    constructionProgress: true,
  })

  const goToConstructionProgressPage = () => {
    setActualPage({ ...emptyPages, constructionProgress: true })
  }
  const goToConstructionMediaPage = () => {
    setActualPage({ ...emptyPages, constructionMedia: true })
  }

  const goToConstructionDocumentsScreenPage = () => {
    setActualPage({ ...emptyPages, constructionDocuments: true })
  }

  return (
    <>
      <ButtonWrapper>
        <Button border={actualPage.constructionProgress} onClick={goToConstructionProgressPage}>
          {formatMessage(messages.constructions_tabs_progress)}
        </Button>
        <Button border={actualPage.constructionMedia} onClick={goToConstructionMediaPage}>
          {formatMessage(messages.constructions_tabs_media)}
        </Button>
        <Button border={actualPage.constructionDocuments} onClick={goToConstructionDocumentsScreenPage}>
          {formatMessage(messages.constructions_tabs_docs)}
        </Button>
      </ButtonWrapper>
      {actualPage.constructionProgress && <ConstructionProgressScreen />}
      {actualPage.constructionMedia && <ConstructionMediaScreen />}
      {actualPage.constructionDocuments && <ConstructionDocumentsScreen />}
    </>
  )
}
